module.exports = __webpack_public_path__ + "img/live_default_thumb.dbe7c37a.png";